// extracted by mini-css-extract-plugin
module.exports = {"root":"Node_root__30gfk","row":"Node_row__3dnye","label":"Node_label__2ZAU_","footer":"Node_footer__1QFxZ"};